<script>
    /**
     * @typedef {import('../../services/ValueService.js').ValueCssColor} ValueCssColor
     */

    import { getContext, setContext } from 'svelte';
    import { ValueService } from '../../services/ValueService.js';

    /**
     * @type {{
     *     bg?: boolean | string | null,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let { bg = null, children } = $props();

    const tableBg = $derived(getContext('ly-table-colors')?.value?.next);
    const tableHeadBg = $derived(getContext('ly-table-thead-colors')?.value?.next);
    const tableHeadRowBg = $derived(getContext('ly-table-thead-row-colors')?.value?.next);
    const useBg = $derived(bg !== null ? bg : (tableHeadRowBg ?? tableHeadBg ?? tableBg ?? true));

    /** @type {{value:ValueCssColor|null}} */
    let colors = $state({ value: null });
    $effect(() => {
        colors.value = ValueService.splitCssColor(useBg, true);
    });
    setContext('ly-table-thead-col-colors', colors);
</script>

<th
    class="small-caps px-4
           py-2 text-left
           align-top text-sm font-bold
           {colors.value?.head ?? 'text-black-700'}">
    {@render children?.()}
</th>
